import { useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { toast } from "react-toastify";
import { RiFileCopyLine } from "react-icons/ri";
import { UncontrolledTooltip } from "reactstrap";

const CopyableText = ({
    t,
    value,
    maxLength = 6,
    showEllipsis = true,
    className = ""
}) => {
    const tooltipId = useMemo(
        () => `copyable-text-${Math.random().toString(36).slice(2, 11)}`,
        []
    );

    const handleCopy = async () => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);

            toast(t("Copied to clipboard."), {
                type: 'success'
            });
        } catch {
            toast(t("Failed to copy."), {
                type: 'error'
            });
        }
    };

    const isTruncated = showEllipsis && value?.length > maxLength;
    const displayValue = isTruncated
        ? `${value.slice(0, maxLength)}...`
        : value;

    return (
        <span className={`d-inline-flex align-items-center ${className}`}>
            <span id={isTruncated ? tooltipId : undefined}>
                {displayValue}
            </span>

            {isTruncated ? (
                <UncontrolledTooltip
                    target={tooltipId}
                    placement="top"
                    trigger="hover"
                    container="body"
                >
                    {value}
                </UncontrolledTooltip>
            ) : null}

            <RiFileCopyLine
                size={16}
                className="ms-2 cursor-pointer text-muted"
                role="button"
                title={t("Copy")}
                onClick={handleCopy}
            />
        </span>
    );
};

export default withNamespaces()(
    CopyableText
);
